"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.completeWizard = exports.wizardForms = exports.wizardResultsBar = exports.wizardWrapElement = exports.advisorElement = void 0;
var state_1 = require("../state");
var helpers_1 = require("./helpers");
var wizardStateManager_1 = require("./wizardStateManager");
// @ts-ignore
var mixitup_1 = __importDefault(require("mixitup"));
// @ts-ignore
var mixitup_pagination_min_js_1 = __importDefault(require("../../../vendor/mixitup-pagination.min.js"));
var LoadmoreHandler_1 = __importDefault(require("../../../helpers/LoadmoreHandler"));
var mixitupAnimation_1 = __importDefault(require("../../../utilities/mixitupAnimation"));
exports.advisorElement = document.querySelector('.FindAnAdvisor');
exports.wizardWrapElement = exports.advisorElement && exports.advisorElement.querySelector('.FindAnAdvisor__mainWrap');
exports.wizardResultsBar = exports.advisorElement && exports.advisorElement.querySelector('.FindAnAdvisor__results');
exports.wizardForms = exports.advisorElement && Array.from(exports.advisorElement.querySelectorAll('form'));
var loadmoreButton = document.querySelector('[data-loadmore]');
var pagination = loadmoreButton ? {
    limit: 8,
    hidePageListIfSinglePage: true
} : {};
if (loadmoreButton) {
    mixitup_1.default.use(mixitup_pagination_min_js_1.default);
}
var mixer = document.querySelector('.Feed--advisors .Feed__container') && new mixitup_1.default('.Feed--advisors .Feed__container', {
    pagination: pagination,
    animation: mixitupAnimation_1.default,
    callbacks: {
        onMixEnd: function () { return updateLoadmore(); }
    }
});
var updateLoadmore = LoadmoreHandler_1.default(loadmoreButton, mixer, { limit: 8, increment: 8 });
var showResultsBar = function () { return exports.wizardResultsBar.classList.remove('is-hidden'); };
var hideWizard = function () {
    // Set a fixed height for this element, so we can transition on it.
    var height = exports.wizardWrapElement.getBoundingClientRect().height.toString();
    exports.wizardWrapElement.style.height = height + 'px';
    // Put this in a 1ms timeout because of how hoisting works.
    setTimeout(function () { return exports.wizardWrapElement.classList.add('is-hidden'); }, 1);
};
var showWizard = function () {
    exports.wizardWrapElement.classList.remove('is-hidden');
    // Remove the height we set earlier. It gets in the way of the wizard.
    setTimeout(function () { return exports.wizardWrapElement.style.height = ''; }, 500);
};
var resetWizardState = function () {
    // Reset form fields
    exports.wizardForms.map(function (form) { return form.reset(); });
    // Reset hidden form fields that are populated by the advisor search
    var hiddenFields = document.querySelectorAll('input[name="your-zip"], input[name="location-preference"], input[name="your-income"], input[name="your-assets"], input[name="your-occupation"], input[name="your-age"], input[name="your-goals"]');
    hiddenFields.forEach(function (field) {
        field.value = '';
    });
    // Reset zipcode lookup icon state
    var zipCodeStatusIcon = document.querySelector('.FAForm__zipInput__status');
    zipCodeStatusIcon === null || zipCodeStatusIcon === void 0 ? void 0 : zipCodeStatusIcon.classList.add('is-hidden');
    zipCodeStatusIcon === null || zipCodeStatusIcon === void 0 ? void 0 : zipCodeStatusIcon.classList.remove('is-valid');
    // Preselect the first location option and trigger change to populate form fields
    var firstLocationOption = document.querySelector('input[data-field-id="1"][type="radio"]');
    if (firstLocationOption) {
        firstLocationOption.checked = true;
        // Trigger change event so form field gets updated
        firstLocationOption.dispatchEvent(new Event('change', { bubbles: true }));
    }
    // Recalculate wizard based on form state
    wizardStateManager_1.updateWizardState();
    // Set all state updates together to ensure proper ordering
    state_1.setState({
        wizard: __assign(__assign({}, state_1.state.wizard), { location: [1] }),
        furthestVisitedStep: 1,
        activeStep: 1,
        zipCode: '',
        matchingAdvisors: state_1.state.advisors,
        availableAdvisorPool: state_1.state.advisors,
        queryInProgress: false
    });
};
var prepareResultsBar = function () {
    exports.wizardResultsBar.style.transition = 'none';
    exports.wizardResultsBar.classList.remove('is-hidden');
    // Set a fixed height for this element, so we can transition on it.
    var wizardResultBarHeight = exports.wizardResultsBar.getBoundingClientRect().height.toString();
    exports.wizardResultsBar.style.height = wizardResultBarHeight + 'px';
    exports.wizardResultsBar.style.transition = '';
    exports.wizardResultsBar.classList.add('is-hidden');
};
var completeWizard = function () {
    var matchingAdvisors = state_1.state.matchingAdvisors;
    var matchingAdvisorElements = helpers_1.getMatchingAdvisorElements(matchingAdvisors);
    state_1.setState({ wizardStatus: 'hide' });
    mixer.filter(matchingAdvisorElements);
    showResultsBar();
};
exports.completeWizard = completeWizard;
exports.default = (function () {
    var updateWizardStatus = function (state, update) { return (update.wizardStatus === 'show' ? showWizard() : hideWizard()); };
    // Open wizard when modify results button is clicked.
    var modifyYourResults = document.querySelector('[data-advisor-modify]');
    modifyYourResults.addEventListener('click', function () { return state_1.setState({ wizardStatus: 'show' }); });
    var restartFormButton = document.querySelector('[data-advisor-restart]');
    restartFormButton.addEventListener('click', function () {
        state_1.setState({ wizardStatus: 'show' });
        resetWizardState();
    });
    prepareResultsBar();
    state_1.subscribe('wizardStatus', updateWizardStatus);
    // Re-filter mixer when matchingAdvisors change if results are showing
    // This handles the case where async queries complete after completeWizard() is called
    state_1.subscribe('matchingAdvisors', function (oldState, update) {
        if (state_1.state.wizardStatus === 'hide' && mixer) {
            var matchingAdvisorElements = helpers_1.getMatchingAdvisorElements(update.matchingAdvisors);
            mixer.filter(matchingAdvisorElements);
        }
    });
});
